/**
 * DateShake Header Component
 * Copyright (c) 2024 DateShake. All rights reserved.
 * 
 * Provides the main navigation header with authentication-aware UI
 */

import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import Modal from './Modal'
import { LoginForm } from '../pages/Login'
import { RegisterForm } from '../pages/Register'

export default function Header() {
	const { user, logout } = useAuth()
	const navigate = useNavigate()
	const [showLogin, setShowLogin] = useState(false)
	const [showRegister, setShowRegister] = useState(false)

	const handleLogoClick = () => {
		if (user) {
			navigate('/dashboard')
		} else {
			navigate('/')
		}
	}

	const handleLogout = () => {
		logout()
		navigate('/')
	}

	return (
		<>
			<header className="sticky top-0 z-40 bg-white/95 backdrop-blur-sm border-b border-black/5">
				<div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
					<button
						onClick={handleLogoClick}
						className="text-2xl font-bold text-gradient-animated hover:scale-105 transition-transform"
					>
						DateShake
					</button>
					
					<div className="flex items-center gap-4">
						{user ? (
							<div className="flex items-center gap-3">
								<span className="text-sm text-black">Welcome, {user.name}</span>
								<button
									onClick={handleLogout}
									className="btn-nav px-4 py-2 text-sm"
								>
									Logout
								</button>
							</div>
						) : (
							<div className="flex items-center gap-3">
								<button
									onClick={() => setShowLogin(true)}
									className="btn-nav px-4 py-2 text-sm"
								>
									Login
								</button>
								<button
									onClick={() => setShowRegister(true)}
									className="btn-primary px-4 py-2 text-sm"
								>
									Get Started
								</button>
							</div>
						)}
					</div>
				</div>
			</header>

			<Modal isOpen={showLogin} onClose={() => setShowLogin(false)} title="Sign in">
				<LoginForm onSuccess={() => setShowLogin(false)} />
			</Modal>
			<Modal isOpen={showRegister} onClose={() => setShowRegister(false)} title="Create your account">
				<RegisterForm onSuccess={() => setShowRegister(false)} />
			</Modal>
		</>
	)
}